//App base
import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Directive } from '@angular/core';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './router.module';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AgGridModule } from 'ag-grid-angular';
import { NgZorroAntdModule, NZ_I18N, en_US, NzDatePickerModule } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import { ModalModule } from 'ngx-bootstrap/modal';
import * as JSzip from 'jszip';
import { NgxSpinnerModule } from 'ngx-spinner';

//App modules
import { HomeModule } from './pages/home/home.module';
import { InspectionModule } from './pages/inspection/inspection.module';
import { PlantMasterModule } from './pages/plantMaster/plantMaster.module';
import { JobPlantModule } from './pages/jobPlant/jobPlant.module';

import * as int from './Interceptor/';

registerLocaleData(en);


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgZorroAntdModule.forRoot(),
    AppRoutingModule,
    NgbModule.forRoot(),
    AgGridModule.withComponents([]),
    NgxSpinnerModule,
    // TooltipModule.forRoot(),
    // ModalModule.forRoot(),

    HomeModule,
    InspectionModule, 
    PlantMasterModule,
    JobPlantModule
  ],
  providers: [{ //provide: NZ_I18N, 
    useValue: en_US,
    provide: HTTP_INTERCEPTORS,
    useClass: int.WinAuthInterceptor,
    multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }

export class AppBootstrapModule { }


